import { render, staticRenderFns } from "./IntercomCreate.vue?vue&type=template&id=63d7f9c4&"
import script from "./IntercomCreate.vue?vue&type=script&lang=js&"
export * from "./IntercomCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports